import { useRetryReportCell } from "@/components/Evaluate/TableComponents/RowCell/hooks/useRetryReportCell";
import { CellActions as CellActionsComponent } from "./CellActions";
import { useUser } from "@/context/user-context";
import { useEffect } from "react";
import { useState } from "react";
import { ReportCell } from "@/types/evaluate";

export const ScoreCellActions = ({
  cell,
  cellValue,
}: {
  cell: ReportCell;
  cellValue: string;
}) => {
  const { activeWorkspaceId: workspaceId } = useUser();
  const { retryReportCell, isLoading: retryReportCellIsLoading } =
    useRetryReportCell(cell.id);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (cell.value && cell.value.value) {
      if (cell.value.value.request_id) {
        setUrl(
          `/workspace/${workspaceId}/request/${cell.value.value.request_id}`,
        );
      } else if (cell.value.value.trace_id) {
        setUrl(`/workspace/${workspaceId}/traces/${cell.value.value.trace_id}`);
      }
    }
  }, [cell.value, workspaceId]);

  return (
    <CellActionsComponent
      plLinkUrl={url}
      onRetry={retryReportCell}
      copyText={cellValue || ""}
      isRetryLoading={retryReportCellIsLoading}
      showRetry
      showCopy
    />
  );
};
